export default {
  name: 'register-form',
  data () {
    return {}
  },
  props: {}
}
